import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import history from '../../history'
import 'url-search-params-polyfill'

import {
  setActiveLanguage,
  getActiveLanguage
} from 'react-localize-redux'

import {
  postValidate,
  postResetPassword,
  setAuthError
} from '../../redux/actions'
import Notify from '../../redux/actions/notifyActions'

import {
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL
} from '../../common/constants'


import PasswordReset from '../../components/passwordreset'
import Typography from 'material-ui/Typography'

class PasswordResetPage extends Component {

  componentWillMount() {
    const params = new URLSearchParams(this.props.location.search)
    this.token = encodeURI(params.get('token')).replace(new RegExp('%20', 'g'), '+')
    this.email = params.get('email')
    if (params.get('language')) {
      this.props.setLanguage(params.get('language'))
    }
    this.props.validate(this.token, this.email)
  }

  render() {

    const {
      translate,
      setLanguage,
      languages,
      activeLanguage,
      valid,
      resetPassword
    } = this.props

    if (valid === true || valid === false) {
      return (
        <PasswordReset
          translate={translate}
          setLanguage={setLanguage}
          activeLanguage={activeLanguage}
          languages={languages}
          token={this.token}
          email={this.email}
          resetPassword={resetPassword}
          isValid = {valid}
        />
      )
    } else {
      return (<div></div>)
    }
  }

}

const mapStateToProps = (state) => ({
  valid: state.passwordresetReducer.valid,
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  languages: state.localeReducer.languages,
  translate: getTranslate(state.localeReducer),
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  validate: (token, email) => {
    dispatch(postValidate({
      token: token,
      email: email
    }))
  },
  setLanguage: (language) => {
    dispatch(setActiveLanguage(language))
  },
  resetPassword: (form) => {
    dispatch(postResetPassword(form)).then((response) => {

      switch (response.type) {
        case RESET_PASSWORD_SUCCESS:
          if (response.payload.data.success) {
            dispatch(Notify.success("password_reset_successfull_toast"))
            history.replace('/login')
          } else {
            dispatch(Notify.error("password_reset_invalid_toast"))
            dispatch(setAuthError(true))
          }
          break
        case RESET_PASSWORD_FAIL:
          dispatch(setAuthError(true))
          dispatch(Notify.error("password_reset_failed_toast"))
          break
      }
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetPage)
